import { getListCompany } from "../data/repository/company.repo";

export const GetListCompanyUseCase = async () => {
  try {
    const resp = await getListCompany();

    return resp.data;
  } catch (error) {
    return error.response.data;
  }
};
